// Mostly copied from sf-next
// https://github.com/stitchfix/sf-next/blob/beta/src/components/FeatureFlags/hooks.ts
import { useMemo } from 'react';
import { useGetFeatureFlagsQuery } from './getFeatureFlags';
import { FeatureFlag } from '../../../types/definitions/vendor/graphql-schema.d';

export type FeatureFlagName = 'client.global.kids_categories';
export type FeatureFlagNames = FeatureFlagName | FeatureFlagName[];
export type GraphQLFeatureFlags = FeatureFlag[];
export type FeatureFlags =
  | Record<FeatureFlagName, boolean>
  | Record<string, boolean>;

type GraphQLQueryOptions = Parameters<typeof useGetFeatureFlagsQuery>[number];
type UseFeatureFlagQueryOption = Partial<
  Pick<GraphQLQueryOptions, 'onCompleted' | 'onError' | 'skip'>
>;

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  'client.global.kids_categories': false,
};

const toFeatureFlags = (graphQLFFs?: GraphQLFeatureFlags): FeatureFlags => {
  if (!graphQLFFs) {
    return {};
  }

  return graphQLFFs.reduce((featureFlags, { name, enabled }) => {
    return {
      ...featureFlags,
      [name]: enabled,
    };
  }, {} as FeatureFlags);
};

/**
 * Retrieves the state of the specified feature flag(s)
 * @param names The name(s) of the desired feature flag(s)
 * @param options GraphQL query options
 */
export const useFeatureFlags = (
  names: FeatureFlagNames,
  options: UseFeatureFlagQueryOption = {},
) => {
  const flagNames = Array.isArray(names) ? names : [names];

  const { data, loading, error } = useGetFeatureFlagsQuery({
    ...options,
    variables: {
      flags: flagNames.map(name => ({ name })),
    },
  });

  const featureFlags = useMemo(() => {
    return data ? toFeatureFlags(data?.client?.featureFlags) : undefined;
  }, [data]);

  return { loading, featureFlags, error };
};
